import React, { useState } from 'react';
import VolumeMute from './VolumeMute';
import VolumeUp from './VolumeUp';
import VolumeDown from './VolumeDown';
import PlayIcon from './PlayIcon';
import PauseIcon from './PauseIcon';
import { checkCorrectPlatform, getTabIndex, readableTimeFormat, toHHMMSS } from '../../helperfunctions/common';
import Rewind from './Rewind';
import Forward from './Forward';
import { PLATFORM_SAMSUNG, PLATFORM_VIZIO, PLAYER_ICON } from '../../constants/common';
import JsSpatialNavigation from '../../ctvnavigation/js-spatial-navigation';
import { ctvEnterKeyDownHandler, keyMappings, speakText } from '../../helperfunctions/ctvHelper';
import videojs from 'video.js';
import CCIcon from './CCIcon';
import PlayerSettingsModal from '../player/PlayerSettingsModal';
import { useSelector } from 'react-redux';

function PlayerProgressBar(props) {
    const { videoId, isLive, ctv_focus_on, theoPlayerRef, theoPlayerIsPaused, theoPlayerVolume, theoPlayerMuted, theoPlayerCurrTime, theoMetaDataLoadedAt, isSamsungAndUserOffline=false} = props;
    const initState = {
        showForward: false,
        showRewind: false,
    }
    const player = theoPlayerRef || document.getElementById(videoId);
    if(!player) return null;
    const [state, setState] = React.useState(initState);
    const [currTime, setCurrTime] = React.useState(toHHMMSS(0))
    const [totalTime, setTotalTime] = React.useState(toHHMMSS(0))
    const [muted, setMuted] = React.useState(player.muted);
    const [volume, setVolume] = React.useState(getVolumeInPercetaage());
    const [isPaused, setIsPaused] = React.useState(player.paused);
    const [ showPlayerSettingModal, setShowPlayerSettingModal ] = useState(false)
    const showSubtitle = useSelector(state => state.feeds.showSubtitle);
    let timeout;
    
    React.useEffect(() => {
        if(!theoPlayerRef) {
            setVideoEventHandler();
        }
        document.addEventListener('keydown', handleRemoteClick);

        return function cleanup() {
            document.removeEventListener('keydown', handleRemoteClick);
            if(!theoPlayerRef) {
                player.ontimeupdate = () => {}
            }
            timeout && clearTimeout(timeout);
        };
    }, []);

    React.useEffect(() => {
        if(theoPlayerRef) {
            setIsPaused(theoPlayerIsPaused);
        }
    }, [theoPlayerIsPaused])

    React.useEffect(() => {
        if(theoPlayerRef) {
            setVolume(theoPlayerVolume);
        }
    }, [theoPlayerVolume])

    React.useEffect(() => {
        if(theoPlayerRef) {
            setMuted(theoPlayerMuted);
        }
    }, [theoPlayerMuted])

    React.useEffect(() => {
        if(theoPlayerRef) {
            setCurrTime(theoPlayerCurrTime);
            if(totalTime == "00:00:00" || isLive) {
                setTotalDur();
            }
        }
    }, [theoPlayerCurrTime])

    React.useEffect(() => {
        if(theoPlayerRef) {
            setTotalDur();
            timeout = setTimeout(() => {showProgressBar()}, 4000);
        }
    }, [theoMetaDataLoadedAt])


    function setVideoEventHandler() {

        player.onloadedmetadata = function() {
            setTotalDur();
            timeout = setTimeout(() => {showProgressBar()}, 4000);
        }
        player.ontimeupdate = function(){
            let currTime = player.currentTime.toFixed();
            setCurrTime(toHHMMSS(currTime))
            if(totalTime == "00:00:00" || isLive) {
                setTotalDur();
            }
            let percentage = ( player.currentTime / player.duration ) * 100;
            if (document.querySelector("#custom-seekbar span.seek")) {
                document.querySelector("#custom-seekbar span.seek").style.width = percentage+"%";
            }
        };
        player.onvolumechange = function() {
            setMuted(player.muted);
            setVolume(getVolumeInPercetaage());
            console.log('volume change', player.volume, player.muted)
        }
        player.onplay = function() {
            setIsPaused(false)
        }
        player.onpause = function() {
            setIsPaused(true)
        }
    }

    function setTotalDur() {
        const dur = player.duration.toFixed() || 0;
        if(isNaN(dur)) {
            setTotalTime("00:00:00");
        } else if (dur === "Infinity") {
            setTotalTime("Live")
        } else {
            setTotalTime(toHHMMSS(dur));
        }
    }

    function handleRemoteClick(e) {
        e.preventDefault()
        if(parseInt(e.keyCode) != 10009 && document.getElementById("video-inlineMenu") && !document.getElementById('video-inlineMenu').classList.contains('closedMenu')) {
            return;
        }
        if(document.getElementById("continue-watching")) {// Continue watching modal is up
            return;
        }

        const focus_on_nav = document.getElementById("nav-bar") ? document.getElementById("nav-bar").contains(document.activeElement) : false;
        const progressBar = document.querySelector('#custom-control-bar');

        if(focus_on_nav || !player || !progressBar) return;

        const remote_action = keyMappings(e.keyCode);
        switch(remote_action) {
            case 'OK':
            case 'DOWN': //down
                showProgressBar();
            break;

            case 'LEFT':
            case 'RIGHT':
                if(!checkCorrectPlatform([PLATFORM_VIZIO])) showProgressBar();
            break;

            case 'UP': // up
                // if(progressBar && progressBar.style.visibility == 'visible') {
                //     progressBar.style.visibility = 'hidden';
                // } else if(progressBar && progressBar.style.visibility == 'hidden') {
                //     if(document.activeElement.id == 'inline_arrow') {
                //         document.getElementById('inline_arrow').blur();
                //     } else {
                //         // showProgressBar();
                //     }
                // }
            break;

            case 'PLAY': //media play
            case 'PAUSE': //media pause
            case 'STOP': // stop video
            case 'PLAY-PAUSE': //media playpause
            case 'FORWARD': //media forward
            case 'REWIND': // media rewinf
                const to_speak = {
                    'PLAY': 'played',
                    'PAUSE': 'paused',
                    'STOP': 'stopped',
                    'PLAY-PAUSE': (player && player.paused) ? 'paused' : 'played',
                    'FORWARD': 'forward 5 seconds',
                    'REWIND': 'rewind 5 seconds'
                };
                speakText(`Video ${to_speak[remote_action]}`);
                // if(player && player.paused) {
                    // showProgressBar();
                // }
            break;
        }
    }

    function showProgressBar() {
        let flag = false
        const progressBar = document.querySelector('#custom-control-bar');
        if (progressBar) {
            if(progressBar.style.visibility == 'hidden') {
                flag = true;
            }
            progressBar.style.visibility = 'visible';
            timeout && clearTimeout(timeout);
            timeout = setTimeout(() => {
                progressBar.style.visibility = 'hidden';
            }, 5000)
            if(flag) {
                setTimeout(() => {
                    JsSpatialNavigation.focus('.play-pause');
                }, 0)
            }
        }
    }

    function getVolumeInPercetaage() {
        return Math.floor(player.volume * 10)*10;
    }

    function onPlayPause() {
        if(isSamsungAndUserOffline) return
        if (player.paused || player.ended) player.play();
        else player.pause();
    }

    function onMute() {
        player.muted = !player.muted;
    }

    function onVolumeUp() {
        player.muted = false;
        let currentVolume = Math.floor(player.volume * 10) / 10;
        if (currentVolume < 1) player.volume += 0.1;
    }

    function onVolumeDown() {
        player.muted = false;
        let currentVolume = Math.floor(player.volume * 10) / 10;
        if (currentVolume > 0) player.volume -= 0.1;
    }

    function onForward() {
        let current_time = player.currentTime;
        player.currentTime = current_time + 5;
        showRwdFwd(PLAYER_ICON.forward)
    }

    function onBackward() {
        let current_time = player.currentTime;
        player.currentTime = current_time - 5;
        showRwdFwd(PLAYER_ICON.rewind)
    }

    function showRwdFwd(type) {
        const iconType = type === PLAYER_ICON.forward ? 'showForward': 'showRewind';
        setState(prevstate => ({...prevstate, [iconType]: true}))
        setTimeout(() => {
            setState(prevstate => ({...prevstate, [iconType]: false}))
        }, 500)
    }

    const onSettings = () => {
        setShowPlayerSettingModal(true)
    }

    const onCancel = () => {
        setShowPlayerSettingModal(false)
    }

    function getDataSnUp() {
        if(videoId && videoId.includes('live-video')) {
            return '#nav-bar .active.focusable:first-child';
        } else if(ctv_focus_on) {
            return ctv_focus_on;
        } else {
            return '#inline_arrow';
        }
    }

    function onSeekBarClick(e) {
        let elm = document.getElementById('custom-seekbar');
        if(!elm) return;

        const total_width = elm.clientWidth;
        const left = e.pageX - elm.offsetLeft;
        const percentage = left / total_width;

        if(!player || !left || !percentage) return;
        
        const vid_time = player.duration * percentage;
        player.currentTime = vid_time;
    }

    const renderPlayerSettingButton = () => {
      if(!showSubtitle) return <></>
      if(theoPlayerRef ? (player.textTracks && !player.textTracks[0]) : (videojs(videoId).textTracks() && !videojs(videoId).textTracks()[0])) return <></>
      return (
        <span
          role="button"
          aria-label={"Closed Captioning"}
          data-sn-up={getDataSnUp()}
          className="cc-icon controls-icon focusable"
          tabIndex={getTabIndex()}
          onClick={onSettings}
        >
          <CCIcon />
        </span>
      );
    };

    return (
      <>
        <div id='custom-control-bar' className="custom-controls">
            <div className="progress-bar">
                <span>{currTime}</span>
                <div id="custom-seekbar" onClick={ onSeekBarClick }>
                    <span className='seek'></span>
                </div>
                <span className='text-right'>{totalTime}</span>
            </div>
            <div className='controls-buttons-div'>
                <span>
                    <span role="button" aria-label={isPaused ? `Play ${readableTimeFormat(player.currentTime.toFixed())}` : `Pause ${readableTimeFormat(player.currentTime.toFixed())}`} data-sn-up={getDataSnUp()} className='play-pause controls-icon focusable' tabIndex={getTabIndex()} onClick={onPlayPause}>
                        {isPaused
                        ?   <PlayIcon />
                        :   <PauseIcon />
                        }
                    </span>
                    <span role="button" aria-label={'rewind'} data-sn-up={getDataSnUp()} className='play-pause rewind controls-icon focusable' tabIndex={getTabIndex()} onClick={onBackward}>
                        <Rewind />
                    </span>
                    <span role="button" aria-label={'forward'} data-sn-up={getDataSnUp()} className='play-pause forward controls-icon focusable' tabIndex={getTabIndex()} onClick={onForward}>
                        <Forward />
                    </span>
                </span>
                <span className="volume">
                    {
                        !checkCorrectPlatform([PLATFORM_VIZIO]) ?
                        <>
                            <span role="button" aria-label={muted ? 'unmute volume' : 'mute volume'} data-sn-up={getDataSnUp()} className={`mute-vol controls-icon focusable ${muted ? 'muted' : ''}`} tabIndex={getTabIndex()} onClick={onMute}>
                                <VolumeMute />
                            </span>
                            <span role="button" aria-label={`volume down`} data-sn-up={getDataSnUp()} className='down-vol controls-icon focusable' tabIndex={getTabIndex()} onClick={onVolumeDown}>
                                <VolumeDown />
                            </span>
                            <span className='volume-level'>
                                {volume}%
                            </span>
                            <span role="button" aria-label={`volume up`} data-sn-up={getDataSnUp()} className='up-vol controls-icon focusable' tabIndex={getTabIndex()} onClick={onVolumeUp}>
                                <VolumeUp />
                            </span>
                            {renderPlayerSettingButton()}
                        </>: <>{renderPlayerSettingButton()}</>
                    }
                </span>
            </div>
            {state.showForward && <Forward />}
            {state.showRewind && <Rewind />}
        </div>
        {showPlayerSettingModal && (
          <PlayerSettingsModal
            onCancel={onCancel}
            player={theoPlayerRef || videojs(videoId)}
          />
        )}
      </>
    );
}

export default PlayerProgressBar